<template>
  <div>
    <button @click.once="goBack">Go Back</button>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>

export default {

  name: 'VaBackButton',

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }

};
</script>





